import styled from "styled-components";

interface CircleButtonGroupWithLabelProps {
  gap?: number;
}

export default styled.div<CircleButtonGroupWithLabelProps>`
  display: flex;
  flex-direction: column;
  width: max-content;
  max-width: 100%;
  align-self: center;
  gap: ${({ gap }) => (gap != null ? `${gap}px` : "unset")};
`;
